import { useContext, useMemo, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';

import { Text, TextType } from 'ui-components/components/text';

import { packagingRequirementsOptions, getAvailablePackagePreferences, EMPTY_REQUIREMENTS, EMPTY_PREFERENCE } from './constants';
import { packagingOptionsMessages } from './messages';
import { SimpleDropdown } from '../../../../components/simple-dropdown';
import { ProductDetailsContext } from '../../context';
import style from '../../style.module.css';

export const PackagingOptionsDropdown = ({ className, disabled = false }) => {
  const { packagingRequirements, setPackagingRequirements, packagePreference, setPackagePreference } = useContext(ProductDetailsContext);

  const packagingRequirementsItems = useMemo(
    () =>
      packagingRequirementsOptions.map((optionId) => ({
        key: optionId,
        name: <FormattedMessage {...packagingOptionsMessages[optionId]} />,
      })),
    [],
  );

  const availablePackagePreferences = useMemo(() => {
    if (!packagingRequirements || packagingRequirements === EMPTY_REQUIREMENTS) {
      return getAvailablePackagePreferences(EMPTY_REQUIREMENTS);
    }
    return getAvailablePackagePreferences(packagingRequirements);
  }, [packagingRequirements]);

  const packagePreferenceItems = useMemo(
    () =>
      availablePackagePreferences.map((optionId) => ({
        key: optionId,
        name: <FormattedMessage {...packagingOptionsMessages[optionId]} />,
      })),
    [availablePackagePreferences],
  );

  useEffect(() => {
    if (packagePreference && !availablePackagePreferences.includes(packagePreference)) {
      setPackagePreference(EMPTY_PREFERENCE);
    }
  }, [availablePackagePreferences, packagePreference, setPackagePreference]);

  return (
    <div className={clsx(style['packaging-options-wrapper'], className)}>
      <div className={style['packaging-label']}>
        <Text textType={TextType.Label} value={packagingOptionsMessages.requirementsLabel} />
      </div>
      <div className={style['packaging-label']}>
        <Text textType={TextType.Label} value={packagingOptionsMessages.preferenceLabel} />
      </div>
      <div className={style['packaging-dropdown-wrapper']}>
        <SimpleDropdown
          defaultTitle={<FormattedMessage {...packagingOptionsMessages[EMPTY_REQUIREMENTS]} />}
          disabled={disabled}
          dropdownMenuShouldHaveWidthOfButton
          fullWidth
          items={packagingRequirementsItems}
          onItemSelected={setPackagingRequirements}
          selectedItemKey={packagingRequirements}
        />
      </div>
      <div className={style['packaging-dropdown-wrapper']}>
        <SimpleDropdown
          defaultTitle={<FormattedMessage {...packagingOptionsMessages[EMPTY_PREFERENCE]} />}
          disabled={disabled}
          dropdownMenuShouldHaveWidthOfButton
          fullWidth
          items={packagePreferenceItems}
          onItemSelected={setPackagePreference}
          selectedItemKey={packagePreference}
        />
      </div>
    </div>
  );
};
